import React from "react";
import { motion } from "framer-motion";
import { LOOKBOOK } from "@/constants/testIds";

const ease = [0.22, 1, 0.36, 1];

// 8 momente — grilă editorială, fără numere, fără etichete.
const items = [
  {
    src: "/images/lookbook/01.jpg",
    title: "Discret.",
    body: "Exact cât trebuie.",
  },
  {
    src: "/images/lookbook/02.jpg",
    title: "Un gest.",
    body: "Restul îl face formula.",
  },
  {
    src: "/images/lookbook/04.jpg",
    title: "Micro-mist.",
    body: "Precizie la fiecare pulverizare.",
  },
  {
    src: "/images/lookbook/06.jpg",
    title: "Atingere aerată.",
    body: "Confort fără greutate.",
  },
  {
    src: "/images/lookbook/07.jpg",
    title: "Piele liniștită.",
    body: "Catifelare care persistă.",
  },
  {
    src: "/images/lookbook/08.jpg",
    title: "Creat pentru ritual.",
    body: "Păstrat pentru frumusețea lui.",
  },
];

export default function Lookbook() {
  return (
    <section
      id="lookbook"
      data-testid={LOOKBOOK.section}
      className="relative py-32 md:py-52 bg-[#FDFBF7] overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-[#2C2826]/10" />

      <div className="mx-auto max-w-[1320px] px-6 md:px-12 lg:px-20">
        {/* Header */}
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-20 mb-24 md:mb-36">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.1, ease }}
            className="col-span-12 md:col-span-5"
          >
            <p className="overline mb-12">— Lookbook</p>
            <h2
              data-testid={LOOKBOOK.title}
              className="font-display text-[2.2rem] leading-[1.15] sm:text-4xl md:text-[3.1rem] lg:text-[3.6rem] text-[#2C2826] tracking-[-0.018em]"
            >
              Descoperă EILEA
              <span className="block mt-3 md:mt-4">
                în <span className="accent-soft">șase imagini</span>.
              </span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.1, ease, delay: 0.1 }}
            className="col-span-12 md:col-span-6 md:col-start-7 md:pt-10"
          >
            <p
              data-testid={LOOKBOOK.intro}
              className="max-w-md text-base md:text-[1.05rem] leading-[1.85] text-[#5C5652] font-light"
            >
              De la primul gest până la senzația care rămâne pe piele.
              O colecție de momente care definesc produsul.
            </p>
            <div className="mt-10 w-16 h-px bg-[#2C2826]/30" />
          </motion.div>
        </div>

        {/* Editorial grid — 3 × 2, mai aerisit */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-12 lg:gap-x-16 gap-y-28 md:gap-y-36">
          {items.map((it, i) => (
            <motion.figure
              key={it.src}
              data-testid={LOOKBOOK.item(i + 1)}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 1, ease, delay: (i % 3) * 0.08 }}
              className="group flex flex-col"
            >
              <div className="relative overflow-hidden bg-[#F4F0EA] aspect-[3/4]">
                <img
                  src={it.src}
                  alt={it.title}
                  data-testid={LOOKBOOK.image(i + 1)}
                  loading="lazy"
                  draggable="false"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04] select-none"
                />
              </div>

              <figcaption
                data-testid={LOOKBOOK.caption(i + 1)}
                className="mt-10 flex flex-col"
              >
                <h3 className="font-serif-classic text-[1.35rem] md:text-[1.45rem] leading-[1.25] text-[#2C2826] tracking-[-0.005em] font-normal">
                  {it.title}
                </h3>
                <p className="mt-5 text-[15px] leading-[1.8] text-[#5C5652] font-light max-w-[34ch]">
                  {it.body}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
